import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import store from '@/store/store';
import router from '@/router/router';
import routes from '../router/routes';

Vue.use(VueToast);

const interceptorResponse = (response) => {
    store.dispatch('cleanErrorResponse');
    return response;
}

const interceptorError = (error) => {
    let { status } = error.response;

    if( status === 401 && store.getters.loggedIn){
        store.dispatch('logOut');
        router.push({ path: routes.login.path });
        Vue.$toast.open({
            message: "Sessão expirada! Efetue o login novamente.",
            type: "error",
            duration: 5000,
            dismissible: true
        });
    }

    const node_env = `${process.env.NODE_ENV}`;
    if (node_env === 'production') {
        console.clear();
    }

    return Promise.reject(error);
}

export {
    interceptorResponse,
    interceptorError
}